import React, {CSSProperties, useEffect, useState} from 'react';
import {alpha, darken, lighten, Theme, useTheme} from "@mui/material/styles";
import {User} from "../lib/stores/UserStore";

export function createMentionStyle(theme: Theme) {
    const isDark = theme.palette.mode === "dark"
    const func = isDark ? lighten : darken;
    const background = alpha(func(theme.palette.background.paper, 0.2), 0.5);
    const color = lighten(theme.palette.background.paper, 0.8);
    return {
        background,
        color,
        borderRadius: "4px",
        padding: "2px 2px",
    }
}

const Mention = ({user, initialStyle = {}}: { user: { id: string } | User, initialStyle?: CSSProperties }) => {
    const theme = useTheme();

    const [style, setStyle] = useState<CSSProperties>(initialStyle);

    const name = user instanceof User ? user.username : "unknown-user";

    useEffect(() => {
        setStyle(createMentionStyle(theme));
    }, [theme])

    return <span
            contentEditable={false}
            style={style}
    >
                {'@' + name}
            </span>
};

export default Mention;
